import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { LoaderInterceptor } from '../api-services';
import { ApiPrefixInterceptor } from '../api-services/api-prefix.interceptor';
import { ErrorHandlerInterceptor } from '../api-services/error-handler.interceptor';
import { NetworkInterceptor } from '../api-services/network.interceptor';

// The dependency injection wiring
export const HTTP_PROVIDERS: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: NetworkInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiPrefixInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorHandlerInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true,
  },
];
